import(/* webpackMode: "eager", webpackExports: ["PageGradientBackground"] */ "/app/src/components/Background/Background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeItem"] */ "/app/src/components/HomeItems/HomeItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/1.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/2.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/3.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/4.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/ai-machine.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/bubbel.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/fantasie-ai.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/klokko-boodschappen.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/krabbel-machine.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/poezie-ai.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/vriendelijk-communiceren.webp");
;
import(/* webpackMode: "eager" */ "/app/src/components/HomeItems/images/werkstuk.webp");
